import { IEvent } from "@quest/adapter-interface";
import { ingenuity, ISpineData, SpineBase } from "@quest/base-core";
import { BaseViewBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class BonusSymTrailView extends BaseViewBehavior {
  // Overrided to align view y position
  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.isDesktop) {
      this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + (SlotConstantsBehavior.REEL_BOTTOM_SPACE / 2) * this.scale.x;
    }
  }

  /**
   * funtion to create clone spine
   * @param spineJson 
   * @returns 
   */
  public createCloneSpine(spineJson: ISpineData): SpineBase {
    let spine = this.createSpine(spineJson);
    return spine;
  }
}
